import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  FormControlLabel,
  useTheme,
} from '@mui/material';

interface SavePlotModalProps {
  open: boolean;
  onClose: () => void;
  plotGroups: PlotGroup[];
  addPlot: boolean;
  onSave: (name: string, plotGroupId: number, isPublic: boolean) => void;
  onSaveAs: (name: string, plotGroupId: number, isPublic: boolean) => void;
  defaultPlotGroupValue: PlotGroup | null;
  isSuperuser: boolean;
}

const SavePlotModal: React.FC<SavePlotModalProps> = ({ open, onClose, plotGroups, addPlot, onSave, onSaveAs, defaultPlotGroupValue, isSuperuser }) => {
  const [name, setName] = useState('');
  const [plotGroupId, setPlotGroupId] = useState<number | ''>('');
  const [isPublic, setIsPublic] = useState(false);
  const theme = useTheme();

  const handleSave = () => {
    if (name !== '' && plotGroupId !== '') {
      if (addPlot) {
        onSave(name, plotGroupId, isPublic);
      }
      else {
        onSaveAs(name, plotGroupId, isPublic)
      }
      onClose();
    } else {
      // Handle validation error
    }
  };

  useEffect(() => {

    if (defaultPlotGroupValue) {
      setPlotGroupId(defaultPlotGroupValue.id)
    }
    else {
      setPlotGroupId('')
    }

  }, [defaultPlotGroupValue])

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      {defaultPlotGroupValue ? <DialogTitle>Add Plot</DialogTitle> : <DialogTitle>Save Plot</DialogTitle>}
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Plot Name"
          type="text"
          fullWidth
          variant="outlined"
          value={name}
          onChange={(event) => setName(event.target.value)}
        />
        {/* <FormControl fullWidth margin="normal">
          <InputLabel>Plot Group</InputLabel>
          <Select
            value={plotGroupId}
            label="Plot Group"
            onChange={(event) => setPlotGroupId(Number(event.target.value))}
          >
            {plotGroups.map((group) => (
              <MenuItem key={group.id} value={group.id}>
                {group.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}
        {isSuperuser &&
          <FormControl component="fieldset" style={{ marginTop: '5px', marginLeft: '5px' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isPublic}
                  onChange={(event) => setIsPublic(event.target.checked)}
                  color="default"
                />
              }
              label={<span style={{ color: theme.palette.text.secondary }}>Public</span>}
            />
          </FormControl>
        } 
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="primary" onClick={handleSave}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SavePlotModal;
